const ORDER_SVC = 'order-svc/3.0/order';
const TRIP_SVC = 'trip-svc/1.0';
const LT_SYS_SVC = 'lt-system-svc/1.0';
const AUTH_SVC = 'auth-svc/1.0';

export const endpoints = {
  AUTH_URL: `${AUTH_SVC}/auth`,
  REFRESH_AUTH_URL: `${AUTH_SVC}/auth/refresh`,
  LT_AUTH_URL: `${LT_SYS_SVC}/auth`,
  LOOKUPS: `${LT_SYS_SVC}/lookups`,
  UPDATE_ORDER_STATUS: `${ORDER_SVC}/change-status`,
  DRIVER_INFO: `${TRIP_SVC}/order/live-tracking`,
  HISTORY: `${LT_SYS_SVC}/history/compact`,
  BRANCH_MENUS: (branchUUID: string) =>
    `${LT_SYS_SVC}/branch/${branchUUID}/menu`,
  MENU_DETAILS: (branchUUID: string, menuUUID: string) =>
    `${LT_SYS_SVC}/branch/${branchUUID}/menu/${menuUUID}`,
  ORDER_DETAILS: (uuid: string) => `${LT_SYS_SVC}/order/${uuid}`,
  ASSIGN_ORDER: `${ORDER_SVC}/assign`,
  ITEM_AVAILABILITY: (branchUUID: string) =>
    `${LT_SYS_SVC}/branch/${branchUUID}/item`,
  REQUEST_MENU_UPDATE: (menuUUID: string) =>
    `${LT_SYS_SVC}/menu/${menuUUID}/request-update`,
  UPDATE_LAST_SEEN: `${LT_SYS_SVC}/user/update-last-seen`,
};
